import React, { useState, useEffect } from "react";
import { Table, Button, Row, Col, Card, Form } from "react-bootstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import {
  deleteAwardhistory,
  getAwardhistory,
} from "../../../../services/AwardhistoryService";
import {
  DatatableWrapper,
  TableBody,
  TableHeader,
  PaginationOptions,
  Pagination,
} from "react-bs-datatable";

const AwardhistoryList = () => {
  const [awardhistory, setAwardhistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    fetchAwardhistory();
  }, []);

  const fetchAwardhistory = async () => {
    try {
      const data = await getAwardhistory();
      setAwardhistory(data);
    } catch (error) {
      console.error("Error fetching awardhistory:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteAwardhistory(id);
      fetchAwardhistory(); // Refresh list after deletion
      console.log("Awardhistory deleted successfully");
    } catch (error) {
      console.error("Error deleting awardhistory:", error);
    }
  };

  // Table headers for the datatable
  const header = [
    { prop: "employeeName", title: "Label" },
    { prop: "employeeEmail", title: "Value" },
    { prop: "awardDate", title: "Award Date" },
    { prop: "isApproved", title: "Approved" },
    { prop: "createdAt", title: "Created At" },
    { prop: "updatedAt", title: "Updated At" },
    {
      prop: "actions",
      title: "Actions",
      cell: (row) => (
        <>
          <Link
            to={"/settings/awardhistory/edit/" + row._id}
            variant="primary"
            className="btn btn-primary shadow btn-xs sharp me-1"
          >
            <i className="fa fa-pencil"></i>
          </Link>
          <Button
            variant="danger"
            className="btn btn-danger shadow btn-xs sharp me-1"
            onClick={() => handleDelete(row._id)}
          >
            <i className="fa fa-trash"></i>
          </Button>
        </>
      ),
    },
  ];

  // Format data for the table
  const tableData = awardhistory.map((awardhistory) => ({
    employeeName: awardhistory.employeeName,
    employeeEmail: awardhistory.employeeEmail,
    awardDate: moment(awardhistory.awardDate).format("YYYY-MM-DD"),
    isApproved: (awardhistory.isApproved == 'true' || awardhistory.isApproved == true) ? 'Approved' : 'Rejected',
    createdAt: moment(awardhistory.createdAt).format("YYYY-MM-DD"),
    updatedAt: moment(awardhistory.updatedAt).format("YYYY-MM-DD"),
    _id: awardhistory._id, // Include for delete/edit actions
  }));

  // Filter the data based on the awardhistory label
  const filteredData = tableData.filter(
    (item) =>
      item.employeeEmail.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <Card>
      <div className="card-body">
        <Row>
          <Col xs={12}>
            <h4>Award History List</h4>
            <Link
              variant="primary"
              to={"/settings/awardhistory/add"}
              className="mb-4 d-flex justify-content-end"
            >
              <Button>Add Award History</Button>
            </Link>

            <DatatableWrapper
              body={filteredData} // Use filtered data for the table
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 5, // Set rows per page
                  options: [5, 10, 15], // Options for rows per page
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Form.Control
                    type="text"
                    placeholder="Search by Employee Email"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                  />
                </Col>
              </Row>

              <Table>
                <TableHeader />
                <TableBody />
              </Table>

              <Row>
                <Col className="d-flex flex-col justify-content-start">
                  <PaginationOptions />
                </Col>
                <Col className="mt-4 d-flex  justify-content-end align-items-end">
                  <Pagination />
                </Col>
              </Row>
            </DatatableWrapper>
          </Col>
        </Row>
      </div>
    </Card>
  );
};

export default AwardhistoryList;
